import { render, staticRenderFns } from "./PictureCheck.vue?vue&type=template&id=6b76e90a&scoped=true"
import script from "./PictureCheck.vue?vue&type=script&lang=js"
export * from "./PictureCheck.vue?vue&type=script&lang=js"
import style0 from "./PictureCheck.vue?vue&type=style&index=0&id=6b76e90a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b76e90a",
  null
  
)

export default component.exports